import config from 'constants/config'

export const useStickyMainHeader = (state: App.State) => {
  const isOfficialHomepage = state.router.location.pathname === `/${state.geo.currentRegionCode.toLowerCase()}`
  const isNewHomepagePreview = config.HOME_PAGE_PREVIEW_ENABLED && state.router.location.pathname === `/${state.geo.currentRegionCode.toLowerCase()}/home-preview`
  return isOfficialHomepage || isNewHomepagePreview
}
